<template>
  <v-expansion-panels class="w-form" v-model="openedPanel" accordion>
    <v-expansion-panel>
      <v-expansion-panel-header class="tit-lev1">Division: [{{ division }}]- Date: [{{ frmDate }}]
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-expansion-panels v-model="cOpenedPanel" accordion>
          <!-- Division -->
          <v-expansion-panel>
            <v-expansion-panel-header>Division: {{ division }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-select label="Select" v-model="cboDivCd" :items="listDivCd" :item-value="`code`" :item-text="`name`" @change = "btnSearch()"></v-select>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- From Date -->
          <v-expansion-panel>
            <v-expansion-panel-header>Check Date: {{ frmDate }} ~ {{ toDate }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="xy-center">
                <div class="mr-2">
                  <v-menu ref="frmDate" :close-on-content-click="false" :return-value.sync="frmDate" offset-y min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="frmDate" label="From Date" readonly v-bind="attrs" v-on="on" hide-details />
                    </template>
                    <v-date-picker v-model="frmDate" no-title scrollable>
                      <v-spacer />
                      <v-btn text @click="$refs.frmDate.isActive = false">
                        Cancel
                      </v-btn>
                      <v-btn text @click="$refs.frmDate.save(frmDate)">
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>
              </div>

              <div class="xy-center">
                <div class="mr-2">
                  <v-menu ref="toDate" :close-on-content-click="false" :return-value.sync="toDate" offset-y min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="toDate" label="To Date" readonly v-bind="attrs" v-on="on" hide-details />
                    </template>
                    <v-date-picker v-model="toDate" no-title scrollable>
                      <v-spacer />
                      <v-btn text @click="$refs.toDate.isActive = false">
                        Cancel
                      </v-btn>
                      <v-btn text @click="$refs.toDate.save(toDate)">
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel> 
        <!-- Ship No -->
          <v-expansion-panel>
            <v-expansion-panel-header>Ship No: {{ ship }}</v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-select label="Select" v-model="cboShipNo" :items="listShip" :item-value="`shipNo`" :item-text="`shipNo`" @change = "btnSearch()"></v-select>
            </v-expansion-panel-content>
          </v-expansion-panel>     
        </v-expansion-panels>          
      </v-expansion-panel-content>
    </v-expansion-panel>
    <!-- End of search condition area -->
    <v-divider></v-divider>
    <!-- List information -->
    <!-- Start search result area -->
    <v-expansion-panel>
      <v-expansion-panel-header class="tit-lev1">
        Result: {{ listSize === 0?'No Data!': listSize }}
        <v-spacer />
        <v-btn  v-if="writeYn" small depressed color="primary" max-width="60px" @click.native.stop="btnAdd"> <span class="caption ">Add</span> </v-btn>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-text-field
          class="mt-2"
          label="Filter"
          prepend-inner-icon="mdi-magnify"
          outlined
          clearable
          clear-icon="mdi-close-circle-outline"
          v-model="txtFilter"
          hide-details
          small
        />
        <v-list nav dense>
          <v-list-item-group>
            <v-divider />
            <v-virtual-scroll bench="50" :items="filteredItems" height="calc(100vh - 270px)" item-height="250">
              <template v-slot:default="{ index, item }">
                <v-list-item :key="index">
                  <v-list-item-title @click="listItemClick(item)" style="text-overflow: ellipsis; white-space:nowrap; overflow:hidden;">
                       <tr>                  
                        <td style="width: 150px"><v-chip color="green" dark small >{{ item.id }}</v-chip></td>
                        <td>                          
                          <v-btn  v-if="writeYn" class="ma-1" small depressed color="primary" max-width="60px" @click.native.stop="btnDelete(item)">
                            <span class="caption ">Delete</span>
                          </v-btn>
                        </td>
                      </tr> 
                      <tr>                  
                        <td style="width: 150px"><strong>Ship No: </strong></td><td><span>{{ item.shipNo }}</span> </td>
                      </tr>                       
                      <tr>                  
                        <td style="width: 150px"><strong>Check Date: </strong></td><td><span>{{ item.chkDte }} </span> </td>
                      </tr>  
                      <tr>                  
                        <td style="width: 150px"><strong>Area: </strong></td><td><span>{{ item.areaCd }}</span> </td>
                      </tr>  
                      <tr>                  
                        <td style="width: 150px"><strong>Department: </strong></td><td><span>{{ item.deptCd }}</span> </td>
                      </tr> 
                      <tr>                  
                        <td style="width: 150px"><strong> Work group: </strong></td><td><span>{{ item.respCd }}</span> </td>
                      </tr> 
                      <tr>                  
                        <td style="width: 150px"><strong>QM Part: </strong></td><td><span>{{ item.qmPart ==='M'?'Outfitting':'Painting' }}</span> </td>
                      </tr>  
                      <tr>                  
                        <td style="width: 150px"><strong>Check Point: </strong></td><td><span>{{ item.chkPntCd }}</span> </td>
                      </tr>  
                      <tr>                  
                        <td style="width: 150px"><strong>Description: </strong></td><td><span>{{ item.descZone }}</span> </td>
                      </tr>
                      <tr>                  
                        <td style="width: 150px"><strong>Countermeasure: </strong></td><td><span>{{ item.rmk}}</span> </td>
                      </tr> 
                      <tr>                  
                        <td style="width: 150px"><strong>Repair Status: </strong></td><td><span>{{ item.zoneSta === 'C'?'Completed':'Not yet' }}</span> </td>
                      </tr> 
                  </v-list-item-title>
                </v-list-item>
                <v-divider :key="item.shipNo + index" />
              </template>
            </v-virtual-scroll>
          </v-list-item-group>
        </v-list>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <!-- End of search result area -->
    <!-- Start detailed dialog -->
    <v-dialog fullscreen persistent v-model="showDetail">
      <v-card>
        <v-toolbar height="55px" class="app_bar_bg" color="primary" dark> 
          <v-chip color="green" dark small >{{ itemDetail.id }}</v-chip>
          <v-spacer />
          <v-btn icon>
            <v-icon @click="showDetail = false">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-sheet style="overflow-x: auto; overflow-y: auto" max-height="calc(100vh - 55px)">
          <div class="pt-3 mr-3" style="display: flex; justify-content: end;">
            <v-btn  v-if="writeYn" small color="primary" class=" mr-2" @click="btnSave">
              Save
            </v-btn>
          </div>
          <v-simple-table style="white-space: normal; word-wrap: break-word; word-break: break-all;">
            <template v-slot:default>
              <tbody>
                <tr>
                  <td style="width: 150px">
                    <strong>Ship No</strong>
                  </td>
                  <td>
                    <v-autocomplete
                      v-model="itemDetail.shipNo"
                      :items="listShip"
                      :item-value="`shipNo`"
                      :item-text="`shipNo`"
                      hide-details
                      dense
                      :readonly="!isNew"
                    />
                  </td>
                </tr>               
                <tr>
                  <td style="width: 110px">
                    <strong>Check Date</strong>
                  </td>
                  <td>
                    <div style="display: flex; justify-content: start;">
                      <v-dialog ref="dialog_chkdte" v-model="modal_chkdate" :return-value.sync="itemDetail.chkDte" persistent width="290px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-model="itemDetail.chkDte" label="" :readonly="!isNew" v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="itemDetail.chkDte" scrollable>
                          <v-btn text color="primary" @click="modal_chkdate = false">
                            Cancel
                          </v-btn>
                          <v-btn text color="primary" @click="$refs.dialog_chkdte.save(itemDetail.chkDte)">
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </div>
                  </td>
                </tr>  
                <tr>
                  <td style="width: 100px">
                    <strong>Area</strong>
                  </td>
                  <td>
                    <v-autocomplete
                      v-model="itemDetail.areaCd"
                      :items="listArea"
                      :item-value="`code`"
                      :item-text="`name`"
                      hide-details
                      dense
                      :readonly="!isNew"
                    />
                  </td>
                </tr>                   
                <tr>
                  <td style="width: 100px">
                    <strong>Department</strong>
                  </td>
                  <td>
                    <v-autocomplete
                      v-model="itemDetail.deptCd"
                      :items="deptList"
                      :item-value="`code`"
                      :item-text="`name`"
                      hide-details
                      dense
                      :readonly="!isNew"
                    />
                  </td>
                </tr>     
                <tr>
                  <td style="width: 100px">
                    <strong>Work Group</strong>
                  </td>
                  <td>
                    <v-autocomplete
                      v-model="itemDetail.respCd"
                      :items="respList"
                      :item-value="`code`"
                      :item-text="`name`"
                      hide-details
                      dense
                      :readonly="!isNew"
                    />
                  </td>
                </tr>   
                 <tr>
                  <td style="width: 100px">
                    <strong>QM Part</strong>
                  </td>
                  <td>
                    <v-autocomplete
                      v-model="itemDetail.qmPart"
                      :items="listQmPart"
                      :item-value="`code`"
                      :item-text="`name`"
                      hide-details
                      dense
                      :readonly="!isNew"
                    />
                  </td>
                </tr> 
                 <tr>
                  <td style="width: 100px">
                    <strong>Check Point</strong>
                  </td>
                  <td>
                    <v-autocomplete
                      v-model="itemDetail.chkPntCd"
                      :items="listChkPoint"
                      :item-value="`code`"
                      :item-text="`name`"
                      hide-details
                      dense
                      :readonly="!isNew"
                    />
                  </td>
                </tr>  
                 <tr>
                  <td style="width: 100px">
                    <strong>Description</strong>
                  </td>
                  <td>
                    <v-text-field v-model.trim="itemDetail.descZone" hide-details dense /> 
                  </td>
                </tr>    
                <tr>
                  <td style="width: 100px">
                    <strong>Countermeasure</strong>
                  </td>
                  <td>
                    <v-text-field v-model.trim="itemDetail.rmk" hide-details dense /> 
                  </td>
                </tr>
                 <tr>
                  <td style="width: 110px">
                    <strong>Completed Date</strong>
                  </td>
                  <td>
                    <div style="display: flex; justify-content: start;">
                      <v-dialog ref="dialog_findte" v-model="modal_findate" :return-value.sync="itemDetail.finDte" persistent width="290px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-model="itemDetail.finDte" label=" " :readonly="!isNew" v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="itemDetail.finDte" scrollable>
                          <v-btn text color="primary" @click="modal_findate = false">
                            Cancel
                          </v-btn>
                          <v-btn text color="primary" @click="$refs.dialog_findte.save(itemDetail.finDte)">
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style="width: 100px">
                    <strong>Before Photo</strong>
                  </td>
                  <td>
                    <tr>
                      <td style="display: flex; justify-content: start;">
                        <div>
                          <div v-if="itemDetail.__created__"></div>
                          <div v-else-if="itemDetail.bfileYn === 'N'">
                            <v-btn small elevation="0" color="transparent" class="px-1 py-0 receiptBtn pt-1" @click="triggerUpload(itemDetail, 'BF')" >
                              Open
                              <v-icon color="blue">$folder</v-icon>
                            </v-btn>
                          </div>
                          <div v-else-if="itemDetail.bfileYn !== 'N'">
                            <v-btn small elevation="0" color="transparent" class="px-1 py-0 receiptBtn pt-1" @click="openFile(itemDetail, 'BF')" >
                              Preview
                              <v-icon color="blue">$search</v-icon>
                            </v-btn>
                          </div>
                        </div>
                      </td>
                      <v-spacer></v-spacer>
                      <td>
                        <div>
                          <div v-if="!itemDetail.__created__ && itemDetail.bfileYn !== 'N'">
                            <v-btn small elevation="0" color="transparent" class="px-1 py-0 receiptBtn pt-1" @click="deleteFile(itemDetail, 'BF')" >
                              Delete
                              <v-icon color="blue">$delete</v-icon>
                            </v-btn>
                          </div>
                        </div>
                      </td>  
                    </tr>                      
                  </td>
                </tr>                
                <tr>
                  <td style="width: 100px">
                    <strong>Repair Staus</strong>
                  </td>
                  <td>
                    <v-autocomplete
                      v-model="itemDetail.zoneSta"
                      :items="listZoneSta"
                      :item-value="`code`"
                      :item-text="`name`"
                      hide-details
                      dense
                      :readonly="!isNew"
                    />
                  </td>
                </tr>  
              </tbody>
            </template>
          </v-simple-table>
          <input type="file" ref="fileInputHidden" style="display: none" accept="image/*" @change="onFileSelected" />
        </v-sheet>
        <div v-if="isPreviewPopupOpen" class="preview-overlay" @click="closePreviewPopup">
          <div class="preview-content" @click.stop>
            <button type="button" class="preview-close-btn" @click="closePreviewPopup">×</button>
            
            <div class="preview-body">
              <embed 
                v-if="previewFileType === 'pdf'" 
                :src="previewFileData" 
                type="application/pdf" 
                class="preview-iframe" 
              />
              
              <img 
                v-else 
                :src="previewFileData" 
                class="preview-img" 
                alt="Preview Content" 
              />
            </div>
            
            <div class="preview-footer">{{ previewFileName }}</div>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <!-- End of detailed dialog -->     
    <!-- Scroll To Top -->
    <v-btn small v-scroll="onScroll" v-show="fab" fab dark fixed bottom right color="primary" @click="toTop">
      <v-icon>mdi-chevron-up</v-icon>
    </v-btn>
  </v-expansion-panels>
  
</template>

<script>
import { getCheckPoint, 
         getArea, 
         getDivision, 
         searchZoneList, 
         saveZone, 
         deleteZone,
         uploadZoneFileFtp,  // <-- Thêm hàm upload file FTP mới
         deleteZoneFile,      // <-- Thêm hàm xóa file FTP mới
         save01, 
         delete1
       } from '@/api/view/tqm/80/v80d3010.js'
import  { getShipList, 
          getDeptList,
          getRespList,
          getQMPartList,
        } from '@/api/view/tqm/80/v80comm.js'       
import { DxScrollView } from 'devextreme-vue/scroll-view'
import { DxPopup } from 'devextreme-vue/popup'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import DxDateBox from 'devextreme-vue/date-box'
import baseview from '@/components/base/baseview.vue' // base page addition
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // Add base when using data grid
import notify from 'devextreme/ui/notify' // message
import { getDateFormat, getCurrentDate } from '@/utils/common.js'
import dayjs from 'dayjs'
import moment from 'moment'
import { fn_uni2vni, fn_vni2uni } from '@/api/view/tqm/common/common.js'
import EventBus from '@/components/event-bus'
import {ftpDownloadViewer} from "@/api/view/tqm/common/common.js";

export default {
  name: 'v80d3010m',
  mixins: [baseview, BaseDataGrid],

  components: {
    DxPopup,
    ICardVertical,
    'i-card-top': iCardTop,
    DxDateBox,
    DxScrollView
    // AppButton,
  },
  props: {},
  data: () => ({
    openedPanel: 0,
    cOpenedPanel: -1,
    txtFilter: '',

    menuTitle: '', //this.$route.meta.title,
    useBtnList: ['btnRetrieve', 'btnAdd'], //,'btnAdd','btnSave', , 'btnDelete'
    selected: [0],
    fab: false,
    dark: false,

    // ĐĂNG KÝ THÊM 2 TRƯỜNG NÀY ĐỂ QUẢN LÝ THAO TÁC UPLOAD FILE
    currentUploadRowData: null, 
    currentUploadDiv: '', // 'BF' hoặc 'AF'

    listClickData: null,

    //Date
    modal_chkdate: '',
    modal_findate: '',

    chkDte: '',
    finDte: '',

    listShip: [],
    listRShip: [],
    cboShipNo: '',

    cboDivCd: '',
    listDivCd: [],
    deptList: [],
    deptCd: '',
    respList: [],
    respCd: '',

    frmDate: moment().format('YYYY-MM-DD'),
    toDate: moment().format('YYYY-MM-DD'),

    cboDivCd: '1',
    gridMainList: [],
    listSize: 0,
    showDetail: false,
    oriItem: {},
    itemDetail: {},
    isNew: false,

    listChkPoint: [],
    listArea: [],
    listQmPart: [
      {code: 'M', name: 'Outfitting'},
      {code: 'P', name: 'Painting'},
    ],
    listZoneSta: [
      {code: 'C', name: 'Completed'},
      {code: 'N', name: 'Not yet'},
    ],
    writeYn: 'N',
    // Thêm các biến quản lý Popup Preview dưới đây:
    isPreviewPopupOpen: false,
    previewFileData: '',
    previewFileType: '',
    previewFileName: '',

    rules: {
      onlyNumbers: value => /^\d+$/.test(value) || "Enter numbers only!"
    }
  }),

  created() {
    // console.log("created: "+this.$options.name + "_search");
    EventBus.$on(this.$options.name + '_search', () => {
      this.btnSearch()
    })
  },

  mounted() {
    
      // console.log("writeYn: ", this.writeYn );
   let toDay = new Date      
    this.frmDate = toDay.setDate(toDay.getDate() - 30);
    toDay = new Date
    this.toDate = toDay.setDate(toDay.getDate() + 0);

    this.toDay = toDay.setDate(toDay.getDate() + 0);

    this.frmDate = dayjs(this.frmDate).format('YYYY-MM-DD')
    this.toDate = dayjs(this.toDate).format('YYYY-MM-DD')
    this.toDay  = dayjs(this.toDay).format('YYYY-MM-DD')

    this.writeYn = this.$gUtil.getWriteYn()
    // console.log("writeYn: ", this.writeYn );
    this.setCombo()
  },

  beforeDestroy() {
    this.writeYn = this.$gUtil.getWriteYn()
    // console.log("beforeDestroy: "+this.$options.name + "_search");
    EventBus.$off(this.$options.name + '_search')
  },

  computed: {
    filteredItems: function() {
      return this.$gUtil.executeFilter(this.gridMainList, this.txtFilter)
    },
    division: function() {
      const items = this.listDivCd.filter(item => item.code && item.code === this.cboDivCd)
      return items.length > 0 ? items[0].name : 'ALL'
    },
    ship: function() {
         const items = this.listShip.filter(item => item.shipNo && item.shipNo === this.cboShipNo);         
         return items.length > 0 ? items[0].shipNo : "ALL";
    },
  },

  methods: {
    onScroll(e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset || e.target.scrollTop || 0
      this.fab = top > 20
    },
    toTop() {
      this.$vuetify.goTo(0)
    },

    onlyNumber(event) {//@keypress="onlyNumber"
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode < 48 || charCode > 57) {
        event.preventDefault();
      }
    },
    filterNumber() {//@input="filterNumber"
      this.numberValue = this.numberValue.replace(/\D/g, ""); // Chỉ giữ lại số
    },
    btnSearch() {
      this.gridMainList = []
      this.doSearchMainList()
    },
    getStrFormat(date) {
      return getDateFormat(date)
    },

    async setCombo() {
      // this.openLoading('Đang tìm')

      let params = { shipNo: '' }

      //getCheckPoint
      const ckeckPoint = async () => {
        await getCheckPoint(params).then(result => {
          this.listChkPoint = result.list
          // result.list.forEach(item => {
          //   this.listChkPoint.push({
          //     name: item.name,
          //     code: item.code
          //   })
          // })
        })
      }
      const ship = async () => {
        await getShipList(params).then(result => {
          // console.log("####res.list", res.list);
          this.listShip = result.list
          // this.listRShip = JSON.parse(JSON.stringify(result.list));
          this.listShip.splice(0, 0, { shipNo: "ALL", shipDesc: "ALL" });
        })
      }

      // getDivision
      const division = async () => {
        await getDivision(params).then(result => {
          // console.log("####result.list", res.list);
          this.listDivCd = result.list
          // this.listDivCd.splice(0, 0, { code: "%", name: "ALL" });
        })
      }

      // getDeptList
      const dept = async () => {
        await getDeptList(params).then(result => {
          result.list.forEach(item => {
            this.deptList.push({
              name: item.deptCd + ': '+ item.deptNm,
              code: item.deptCd
            })
          })
        })
      }

      let params1 = { deptCd: '' }
      // getRespList
      const resp = async () => {
        await getRespList(params1).then(result => {
          result.list.forEach(item => {
            this.respList.push({
              name: item.respCd + ': '+ item.respNm,
              code: item.respCd,
              deptCd: item.deptCd || ''
            })
          })
        })
      }
      // getArea
      const area = async () => {
        await getArea(params).then(result => {
          // console.log("####result.list", res.list);
          this.listArea = result.list
          // this.listArea.splice(0, 0, { code: "%", name: "ALL" });
        })
      }

      this.$qLoading.show()

      await Promise.all([ship(), division(), dept(), resp(), area(), ckeckPoint()])
        .catch(ex => {
          //    this.$qMsgBox.show(this, this.$gUtil.getSqlError(ex), ['ok']);
        })
        .finally(() => {
          this.$qLoading.hide()
        })
    },
    /**
    * Hàm lọc danh sách Work Group tương ứng với dòng Department đang chọn
    */
    getFilteredWorkGroups(options) {
      return {
          store: this.respList,
          // Lấy giá trị deptCd của dòng hiện tại để thực hiện filter dữ liệu trên Grid
          filter: options.data ? ['deptCd', '=', options.data.deptCd] : null
      };
    },
    getFilteredCheckPoint(options) {
      return {
          store: this.listChkPoint,
          // Lấy giá trị qmPart của dòng hiện tại để thực hiện filter dữ liệu trên Grid
          filter: options.data ? ['qmPart', '=', options.data.qmPart] : null
      };
    },
    /**
    * Sự kiện kích hoạt khi người dùng thay đổi phòng ban trên Grid.
    * Giúp tự động xóa sạch Work Group cũ tránh râu ông nọ cắm cằm bà kia.
    */
    onDepartmentChanged(newData, value, currentRowData) {
      // Gán giá trị Department mới cho dòng
      newData.deptCd = value;  
      // Reset giá trị Work Group (respCd) về null trên giao diện dòng đó
      newData.respCd = null;
    },
    onCheckPointChanged(newData, value, currentRowData) {
      // Gán giá trị QM Part mới cho dòng
      newData.qmPart = value;
      // Reset giá trị Check Point (chkPntCd) về null trên giao diện dòng đó
      newData.chkPntCd = null;
    },
    /**
     * BƯỚC 1: Khi nhấn Open, lưu thông tin dòng và kích hoạt hộp thoại chọn file của Windows
     */
    triggerUpload(cellData, divType) {           
      this.currentUploadRowData = cellData; // Lưu nguyên object hàng đang click
      this.currentUploadDiv = divType;           // Nhận diện 'BF' hoặc 'AF'

      // console.log('===currentUploadRowData: ', cellData);
      // console.log('===currentUploadDiv: ', divType);
      
      // Kích hoạt click vào thẻ input file ẩn dán ở cuối template
      this.$refs.fileInputHidden.click();
    },
    /**
     * BƯỚC 2: Xử lý ngay sau khi người dùng chọn xong file ảnh từ máy tính
     */
    async onFileSelected(event) {
      const file = event.target.files[0];
      if (!file) return;

      // Chuẩn bị FormData đóng gói để gửi lên API Backend
      const formData = new FormData();
      formData.append("file", file);
      formData.append("shipNo", this.currentUploadRowData.shipNo);
      formData.append("zoneSeq", this.currentUploadRowData.zoneSeq); // Đảm bảo dòng đã có khóa chính DB
      formData.append("fileType", this.currentUploadDiv); // Truyền 'BF' hoặc 'AF'

      try {
        this.openLoading('Uploading file to FTP...');
        
        // Gọi API upload file FTP lên Backend Java
        const response = await uploadZoneFileFtp(formData);
        // console.log('response', response);
        
        // === ĐOẠN CẬP NHẬT MỚI CHUẨN XÁC ===
        if (response) {
          let isSuccess = false;
          let serverMessage = '';

          // 1. Phân tích dữ liệu phản hồi (Ép kiểu từ chuỗi JSON nếu có)
          let resData = response.data;
          if (typeof resData === 'string') {
            try {
              // Nếu Backend trả về chuỗi dạng JSON object, tiến hành chuyển đổi sang Object JS
              resData = JSON.parse(resData);
            } catch (e) {
              // Nếu là chuỗi text đường dẫn thô thông thường, giữ nguyên
            }
          }

          // 2. KIỂM TRA ĐIỀU KIỆN THÀNH CÔNG ĐA TẦNG
          if (
            response.status === 200 || 
            response.status === 'SUCCESS' ||
            resData?.status === 'SUCCESS' ||
            (typeof response.data === 'string' && response.data.includes('/attachfile/')) ||
            (resData?.data && String(resData.data).includes('/attachfile/'))
          ) {
            isSuccess = true;
          } else {
            serverMessage = resData?.message || resData?.msg || '';
          }

          // 3. HIỂN THỊ THÔNG BÁO VÀ RELOAD GRID DỮ LIỆU
          if (isSuccess) {
            // Bắn thông báo thành công xanh mượt chuẩn hệ thống
            this.vToastify(this.$t('Upload file successfully...'), 'success');

            // Reload lại Grid để cập nhật dữ liệu hiển thị file mới nhất
            if (typeof this.doSearchMainList === 'function') {
              this.doSearchMainList();
            } else if (typeof this.searchList === 'function') {
              this.searchList();
            }
          } else {
            // Hiển thị thông báo lỗi chi tiết từ server nếu có
            this.vToastify(serverMessage || 'Upload failed from server', 'warn');
          }
        }

      } catch (error) {
        console.error("Upload error log:", error);
        this.vToastify(response.data?.message || 'Upload failed', 'warn');
      } finally {
        event.target.value = ''; // Reset input để lần sau chọn lại file cũ không bị kẹt sự kiện
        this.endLoading();
      }
    },
    /**
     * BƯỚC 3: Sửa lại hàm xem ảnh (Preview)
     */
    async openFile(e, divType) {
      // Vì DxDataGrid cell-template truyền qua biến "data", chúng ta bóc tách dữ liệu gốc ra:
      // console.log("rowData:", e);
      // console.log("divType:", divType);
      const rowData = e;
      let fileName = divType === 'BF' ? rowData.fileNmBf : rowData.fileNmAf;
      let filePath = '';
      if (!fileName) {
        this.vToastify('No file name found to preview!', 'warn');
        return;
      }
      // console.log('######fileName===>', fileName)
      try {
        this.openLoading('Loading file preview...');
        
        filePath = 'attachfile/TQM/ZONE_FINAL/' + rowData.shipNo + '/' + fileName;

        // console.log('######filePath===>', filePath)
        
        // Gọi API chung có sẵn của hệ thống
        const response = await ftpDownloadViewer(filePath, 'temp_file'); 
        const fileRes = response.data || response; 

        if (fileRes && fileRes.body) {
          const ext = fileName.split('.').pop().toLowerCase();
          let dataType = `data:image/${ext};base64,`;
          
          if (ext === 'pdf') {
            dataType = "data:application/pdf;base64,";
          }

          // 1. Gán dữ liệu Base64 đầy đủ vào biến state
          this.previewFileData = dataType + fileRes.body;
          this.previewFileType = ext;
          this.previewFileName = fileName;

          // 2. Bật Popup lơ lửng xuất hiện bừng sáng màn hình
          this.isPreviewPopupOpen = true;

        } else {
          this.vToastify('Could not load file content from server.', 'warn');
        }

      } catch (error) {
        console.error("Preview Error:", error);
        this.vToastify(error.message || 'Preview failed', 'warn');
      } finally {
        this.endLoading();
      }
    }, 
    // Hàm đóng popup khi nhấn dấu X hoặc click ra ngoài màn hình nền tối
    closePreviewPopup() {
      this.isPreviewPopupOpen = false;
      this.previewFileData = '';
      this.previewFileType = '';
      this.previewFileName = '';
    },
    /**
     * BƯỚC 4: Sửa lại hàm xóa file vật lý đính kèm
     */
    /**
     * Sửa lại hàm xóa file vật lý đính kèm theo Cách A (Phòng vệ đa tầng kết quả trả về)
     */
    async deleteFile(e, divType) {
      const rowData = e;
      let fileName = divType === 'BF' ? rowData.fileNmBf : rowData.fileNmAf;
      const targetPhotoType = divType === 'BF' ? 'Before' : 'After';
      // console.log('######rowData===>', rowData)
      if (!fileName) return;

      // Bước 1: Hiển thị hộp thoại hỏi Xác nhận (Prompt) trước khi xóa
      this.vToastifyPrompt(
        `Do you want to delete this ${targetPhotoType} photo file on FTP Server?`,
        'info',
        async current => {
          this.openLoading('Deleting file on FTP...');
          try {
            const params = {
              shipNo: rowData.shipNo,
              zoneSeq: rowData.zoneSeq,
              fileType: divType,
              fileName: fileName
            };
            
            // Gọi API Axios thực hiện xóa file trên FTP
            const response = await deleteZoneFile(params);
            // console.log('deleteZoneFile response:', response);
            
            // Ép kiểu phân tích dữ liệu phòng vệ tương tự như hàm Upload đã chạy thành công
            let resData = response?.data;
            if (typeof resData === 'string') {
              try {
                resData = JSON.parse(resData);
              } catch (jsonErr) {
                // Giữ nguyên chuỗi thô nếu không phải JSON
              }
            }

            // Bước 2: KIỂM TRA ĐIỀU KIỆN THÀNH CÔNG ĐA TẦNG ĐỒNG BỘ VỚI HÀM UPLOAD
            if (
              response?.status === 200 || 
              response?.status === 'SUCCESS' ||
              resData?.status === 'SUCCESS' ||
              String(resData).includes('SUCCESS')
            ) {
              
              // Bước 3: Bắn thông báo Toastify dạng 'success' màu xanh mượt mà lên góc màn hình
              this.vToastify(this.$t('Deleted photo successfully!'), 'success');                        
              
              // Bước 4: Làm tươi lưới dữ liệu Grid từ DB để cập nhật trạng thái cờ file về 'N' (Hiện lại nút Open)
              if (typeof this.doSearchMainList === 'function') {
                this.doSearchMainList();
              } else if (typeof this.searchList === 'function') {
                this.searchList();
              }

            } else {
              // Trường hợp API chạy qua nhưng Backend trả về nội dung lỗi cụ thể
              this.vToastify(resData?.message || 'Delete file failed from server', 'warn');
            }

          } catch (error) {
            console.error("Delete FTP File Error:", error);
            this.vToastify(error.message || 'Delete failed', 'warn');
          } finally {
            this.endLoading();
          }
        },
        null,
        true
      );
    },
    async doSearchMainList() {
      try {
        this.openLoading('Loading...')
        let params = {
            divCd: this.cboDivCd,
            shipNo: this.cboShipNo == "ALL" ? '%': this.cboShipNo,
            frmDate: this.frmDate,
            toDate: this.toDate
          }
        // console.log('######params===>', params)
        await searchZoneList(params).then(res => {

          if (res.list.length > 0) {
            this.gridMainList = res.list
            this.listSize = res.list.length            
            this.openedPanel = 1
            // console.log('res', res.list.length);
          } else {
            this.gridMainList.splice(0)
             this.listSize = 0
            // notify('No Data', 'error', 5000)
            // this.vToastify(this.$t('No Data.'), 'warn')
            // this.$gUtil.showToast(this, 'No Data!')
          }
          // console.log('######listSize===>', this.gridMainList)
        })
      } finally {
        this.endLoading()
      }
    },

    btnAdd() {
      if (!this.cboShipNo || this.cboShipNo === "ALL") {
        this.vToastify(this.$t('Please, select Ship No to Add.'), 'warn')
        return
      }

      this.isNew = true
      this.btnResetClick()
      this.showDetail = true
      this.itemDetail.shipNo = this.cboShipNo
      this.itemDetail.chkDte = this.frmDate
      this.itemDetail.bfileYn =  'N'
      this.itemDetail.afileYn = 'N'
      this.itemDetail.userId = this.$store.state.user.userId
      this.itemDetail.__modified__ = false
      this.itemDetail.__created__  = true
    },
    async btnSave() {
     
      if (!this.writeYn) {
          this.vToastify(this.$t('You no have authority to Add.'), 'warn')
          return
        }

      if (!this.itemDetail.shipNo) {
        this.vToastify(this.$t('requiredCheck') + '[Ship No]', 'warn')
        return
      }

      const param = {
                  zoneSeq: this.itemDetail.zoneSeq !=null ? this.itemDetail.seq: null,
                  shipNo: this.itemDetail.shipNo,
                  chkDte: this.itemDetail.chkDte,
                  areaCd: this.itemDetail.areaCd,                  
                  qmPart: this.itemDetail.qmPart,
                  deptCd: this.itemDetail.deptCd,
                  respCd: this.itemDetail.respCd,
                  chkPntCd: this.itemDetail.chkPntCd,
                  descZone: this.itemDetail.descZone,
                  rmk: this.itemDetail.rmk,
                  zoneSta: this.itemDetail.zoneSta,
                  finDte: this.itemDetail.finDte,
                  userId: this.$store.state.user.userId,

                  __modified__: this.isNew === true ? false: true,
                  __created__: this.isNew === true ? true :false,
                }

        console.log('######param===>', param)  
         try{
              this.openLoading('searching')
              await saveZone(param).then(result => {
                console.log('result', result)
                this.itemDetail = result.map.retValue;                
                if (this.isNew) {
                  this.isNew = false;
                  this.itemDetail = result.map.retValue;
                  this.oriItem = JSON.parse(JSON.stringify(this.itemDetail));
                  this.gridMainList.splice(0, 0, this.oriItem);
                }
                else {
                  console.log('else', 'Error!')
                  this.oriItem.finDte = result.map.retValue.finDte !=null?result.map.retValue.finDte:'';
                  this.oriItem.zoneSta = result.map.retValue.zoneSta!=null?result.map.retValue.zoneSta:'';
                  this.oriItem.descZone = result.map.retValue.descZone !=null?result.map.retValue.descZone:'';
                  this.oriItem.chkPntCd = result.map.retValue.chkPntCd !=null?result.map.retValue.chkPntCd:'';
                  this.oriItem.respCd = result.map.retValue.respCd !=null?result.map.retValue.respCd:'';
                  this.oriItem.deptCd = result.map.retValue.deptCd !=null?result.map.retValue.deptCd:'';
                  this.oriItem.rmk = result.map.retValue.rmk !=null?result.map.retValue:'';
                  this.oriItem.qmPart = result.map.retValue.qmPart!=null?result.map.retValue.qmPart:'';
                  this.oriItem.areaCd = result.map.retValue.areaCd !=null?result.map.retValue.areaCd:'';
                  this.oriItem.userId = result.map.retValue.userId !=null?result.map.retValue.userId:'';
                  this.oriItem.chkDte = result.map.retValue.chkDte !=null?result.map.retValue.chkDte:'';
                  this.oriItem.shipNo = result.map.retValue.shipNo !=null?result.map.retValue.shipNo:'';
                  this.oriItem.zoneSeq = result.map.retValue.zoneSeq !=null?result.map.retValue.zoneSeq:'';

                  this.oriItem.__modified__ = result.map.retValue.__modified__;
                  this.oriItem.__created__ = result.map.retValue.__created__;
                }
                this.showDetail = false
                notify('Saved', 'success', 3000)

              })
              .catch(error => {
                this.vToastify(error, 'warn')
                this.endLoading()
              })
              .finally(() => {
                this.btnSearch()
              })
            } finally{
              this.endLoading()
            }       
    },

    async btnDelete(item) {
      // console.log('######btnDelete===>', item.shipno)
       const realRowsToDelete = [];
      // 1. Kiểm tra quyền hạn ghi/xóa của User
      if (!this.writeYn) {
        this.vToastify(this.$t('You do not have authority to Delete.'), 'warn');
        return;
      }

      realRowsToDelete.push(item);
      // Nếu có file Before -> Gọi API xóa file vật lý trên FTP trước
      if (item.fileNmBf && item.bfileYn !== 'N') {
        try {
          await deleteZoneFile({
            shipNo: item.shipNo,
            zoneSeq: item.zoneSeq,
            fileType: 'BF',
            fileName: item.fileNmBf
          });
        } catch (ftpErr) {
          console.warn("Ignore FTP Before Delete Error:", ftpErr);
        }
      }

      // Nếu có file After -> Gọi API xóa file vật lý trên FTP trước
      if (item.fileNmAf && item.afileYn !== 'N') {
        try {
          await deleteZoneFile({
            shipNo: item.shipNo,
            zoneSeq: item.zoneSeq,
            fileType: 'AF',
            fileName: item.fileNmAf
          });
        } catch (ftpErr) {
          console.warn("Ignore FTP After Delete Error:", ftpErr);
        }
      }

      const param = { 
                  shipNo: item.shipNo,
                  zoneSeq: item.zoneSeq,
                }
        console.log('######realRowsToDelete===>', realRowsToDelete)  
        console.log('######param===>', param) 
         try{
              this.openLoading('searching')
              await deleteZone(param).then(result => {
                // console.log('result', result)                
                notify('Deleted', 'success', 3000)

              })
              .catch(error => {
                this.vToastify(error, 'warn')
                this.endLoading()
              })
              .finally(() => {
                this.btnSearch()
              })
            } finally{
              this.endLoading()
            } 
    },

    listItemClick(item) {
      // console.log('######listItemClick===>', item.shipno)
      this.isNew = false
      this.oriItem = item
      this.itemDetail = JSON.parse(JSON.stringify(item))
      this.showDetail = true
      //  console.log('######itemDetail===>', this.itemDetail)
    },

    uppercase() {
      this.block = this.block.toUpperCase()
    },

    btnResetClick() {
      this.isNew = true

      this.oriItem = {}
      this.itemDetail = {}
    }
  }
}
</script>
<style scoped>
/* Lớp nền tối mờ bao phủ toàn màn hình */
.preview-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8); /* Màu nền đen mờ tỉ lệ 80% */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999; /* Chỉ số z-index siêu cao để đè lên DxDataGrid và Menu hệ thống */
}

/* Khung nội dung trung tâm chứa ảnh / PDF */
.preview-content {
  position: relative;
  background-color: #1e1e1e;
  border-radius: 8px;
  width: 85%;
  max-width: 1000px;
  height: 85%;
  max-height: 750px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.6);
  overflow: hidden;
  border: 1px solid #3c3c3c;
}

/* Nút đóng hình dấu X ở góc trên bên phải */
.preview-close-btn {
  position: absolute;
  top: 10px;
  right: 20px;
  background: none;
  border: none;
  color: #ffffff;
  font-size: 36px;
  font-weight: bold;
  cursor: pointer;
  z-index: 100000;
  line-height: 1;
  transition: color 0.2s, transform 0.2s;
}
.preview-close-btn:hover {
  color: #ff4d4d; /* Đổi sang màu đỏ rực khi hover chuột vào */
  transform: scale(1.1);
}

/* Vùng không gian chính hiển thị nội dung file */
.preview-body {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px;
  overflow: hidden;
  background-color: #090909; /* Nền tối tuyệt đối tôn dáng hình ảnh */
}

/* Định dạng hình ảnh co giãn theo tỷ lệ chuẩn */
.preview-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 4px;
}

/* Định dạng khung iframe nhúng tài liệu (PDF) */
.preview-iframe {
  width: 100%;
  height: 100%;
  border: none;
  background-color: #ffffff;
}

/* Thanh hiển thị tên file dưới chân Popup */
.preview-footer {
  padding: 12px;
  background-color: #1a1a1a;
  color: #aaaaaa;
  text-align: center;
  font-size: 13px;
  font-family: Arial, sans-serif;
  border-top: 1px solid #2d2d2d;
}
</style>

